import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subject, BehaviorSubject } from 'rxjs';
import { ImportUserService } from '../import-user/import-user.service';
import { VnMappingImportService } from './vn-mapping-import.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-vn-mapping-import',
  templateUrl: './vn-mapping-import.component.html',
  styleUrls: ['./vn-mapping-import.component.css']
})
export class VnMappingImportComponent implements OnInit {
 @ViewChild('validationError') validationErrorModel!: TemplateRef<any>;
  isLoading: Subject<boolean> = new Subject<boolean>();
  @ViewChild('fileInput') fileInput!: ElementRef;
  headers: any = [];
  constructor(public dialog: MatDialog, private toastr: ToastrService, private importUserService: VnMappingImportService) { }
  ngOnInit(): void {

  }

  file: File | any = null;
  uploadedFile: File | any = null;

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onFileDrop(event: any) {
    event.preventDefault();
    this.file = event.dataTransfer.files[0];
    if (event.dataTransfer && event.dataTransfer.files.length) {
      this.validateFile(event.dataTransfer.files[0]);
    }
  }

  onFileSelect(event: any) {
    const input = event.target as HTMLInputElement;
    // const files: FileList = event.target.files;
    this.file = event.target.files[0];
    if (input.files && input.files.length) {
      this.validateFile(input.files[0]);
    }
  }

  validateFile(file: File) {
    const validExtensions = ['csv', 'xlsx', 'xls'];
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB in bytes
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    const fileSize = file.size;

    if (fileExtension && validExtensions.includes(fileExtension)) {
      // if (fileSize <= maxSizeInBytes) {
      this.uploadedFile = file;
      // } else {
      //   this.toastr.error('File size exceeds 10MB!');
      //   this.uploadedFile = null;
      //   this.file = null;
      // }
    } else {
      this.toastr.error('Invalid file type!');
      this.uploadedFile = null;
      this.file = null;
    }
  }

  validationData: any = []
  uploadFile() {
    this.validationData = [];
    if (this.file) {
      this.isLoading = new BehaviorSubject<boolean>(true);
      const formData: any = new FormData();
      formData.append('vnMapFile', this.file);
      this.importUserService.bulkUploadOutlet(formData).subscribe((res: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        if (res.body.responseCode == 200) {
          this.deleteFile();
          this.exportBulkImportResponse(res.body.data);
          this.toastr.success(res.body.responseMessage);
        } else {
          this.exportBulkImportResponse(res.body.data);
          this.toastr.error(res.body.responseMessage);
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    } else {
      this.toastr.error('No file selected or invalid file type!');
    }
  }


  openValidations() {
    this.dialog.open(this.validationErrorModel, {
      width: '600px',
      height: '70vh'
    });
  }

  deleteFile(): void {
    this.uploadedFile = null;
  }
  onClose() {
    this.dialog.closeAll();
  }

  exportBulkImportResponse(data: any) {
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    const successSheetData = data.successRecords.map((r:any) => ({
      ID: r.id,
      "Virtual Number": r.virtual_number
    }));
    const wsSuccess: XLSX.WorkSheet = XLSX.utils.json_to_sheet(successSheetData);
    XLSX.utils.book_append_sheet(wb, wsSuccess, 'Success Records');

    const failedSheetData = data.failedRecords.map((r:any) => ({
      Row: r.row,
      Errors: r.errors.join(', ')
    }));
    const wsFailed: XLSX.WorkSheet = XLSX.utils.json_to_sheet(failedSheetData);
    XLSX.utils.book_append_sheet(wb, wsFailed, 'Failed Records');

    const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, 'bulk_import_result.xlsx');
  }
  downloadFile() {
  const fileUrl = 'https://d1sn8rvxrcf2ob.cloudfront.net/sample_vn_mapping.xlsx';
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = 'sample_vn_mapping.xlsx'; // Optional: custom file name
  link.target = '_blank'; // Opens in new tab if needed
  link.click();
}

}
